class Wishlist {
  constructor() {
    this.isWishlistPage = false;
    this.storageKey = 'bt-wishlist-products';
    this.products = [];
    this.productNodes = {};

    this.pageTemplate = 'page.product-wishlist';
    this.addedClass = 'bt-added-to-wishlist';
    this.hasItemClass = 'bt-wishlist-has-item';
    this.selectors = {
      container: '.bt-wishlist-page-content__wrapper',
      noProducts: '.bt-wishlist-no-products',
      wrapper: '.bt-wishlist-card',
      productCard: '.bt-card-product-wrapper',
      wishlistButton: '.bt-product-wishlist-btn',
      wishlistText: '.bt-wishlist-button-text',
      removeButton: '.bt-wishlist-remove-button',
      count: '.bt-wishlist-count',
      skeleton: '.bt-product-skeleton',
    };
    this.products = Array.from(new Set(Array.from(JSON.parse(localStorage.getItem(this.storageKey)) || [])));
    this.isWishlistPage = UtenzoSettings.template === this.pageTemplate;
    this.init();
  }

  init = async () => {
    if (this.isWishlistPage) {
      await this.renderWishlistPage();
      this.addEventToRemoveButtons();
    }
    this.setWishlistButtonsState();
    this.addEventToWishlistButtons();
    this.updateWishlistCount();
  };

saveToStorage = () => {
  this.products = Array.from(new Set(this.products));

  localStorage.setItem(
    this.storageKey,
    JSON.stringify(this.products)
  );

  // Notify the header whenever the wishlist changes
  window.dispatchEvent(new CustomEvent('wishlist:updated', {
    detail: {
      products: this.products,
      count: this.products.length
    }
  }));
};

  addToWishlist(handle) {
    if (handle && this.products.indexOf(handle) === -1) {
      this.products.push(handle);
      this.saveToStorage();
    }
  }

  removeFromWishlist(handle) {
    this.products = this.products.filter((hdl) => hdl !== handle);
    this.saveToStorage();
  }


setWishlistButtonsState = () => {
  const buttons = document.querySelectorAll(this.selectors.wishlistButton);

  buttons.forEach((btn) => {
    const productHandle = btn.dataset.productHandle;
    const isAdded = this.products.includes(productHandle);

    btn.classList.toggle(this.addedClass, isAdded);
    btn.setAttribute('aria-pressed', String(isAdded));
  });
};


  updateWishlistCount = () => {
    const size = this.products.length;
    const countElems = document.querySelectorAll(this.selectors.count);
    [...countElems].forEach((elem) => {
      elem.textContent = size;
      if (size < 1) {
        elem.classList.add('hidden');
      } else {
        elem.classList.remove('hidden');
      }
    });
    const method = size ? 'add' : 'remove';
    document.body.classList[method](this.hasItemClass);
  };


addEventToWishlistButtons = () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(this.selectors.wishlistButton);

    if (!btn) return;

    e.preventDefault();

    const productHandle = btn.dataset.productHandle;

    if (!productHandle) return;

    const isAlreadyAdded = this.products.includes(productHandle);

    if (isAlreadyAdded) {
      this.removeFromWishlist(productHandle);
    } else {
      this.addToWishlist(productHandle);
    }

    // Synchronize every heart button for this product
    document.querySelectorAll(this.selectors.wishlistButton).forEach((button) => {
      if (button.dataset.productHandle === productHandle) {
        const isAdded = this.products.includes(productHandle);

        button.classList.toggle(this.addedClass, isAdded);
        button.setAttribute('aria-pressed', String(isAdded));
      }
    });

    this.updateWishlistCount();
  });
};


  toggleButtonState = (btn, active) => {
    const productHandle = btn && btn.dataset.productHandle;
    const wishlistText = btn && btn.querySelector(this.selectors.wishlistText);

    if (active) {
      this.addToWishlist(productHandle);
      btn.classList.add(this.addedClass);
    } else {
      this.removeFromWishlist(productHandle);
      btn.classList.remove(this.addedClass);
    }

    if (wishlistText) {
      const temp = wishlistText.dataset.revertText;
      wishlistText.dataset.revertText = wishlistText.textContent;
      wishlistText.textContent = temp;
    }
  };

  addEventToRemoveButtons = () => {
    addEventDelegate({
      selector: this.selectors.removeButton,
      handler: (e, btn) => {
        e.preventDefault();
        const prod = btn && btn.closest(this.selectors.wrapper);
        prod && prod.remove();

        const productHandle = btn && btn.dataset.productHandle;
        if (productHandle) {
          this.removeFromWishlist(productHandle);
          this.updateWishlistCount();
          if (!this.products.length) {
            this.showNoProductsMessage();
          }
        }
      },
    });
  };

  wishlistRemoveButton(prdHandle) {
    const html = `<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>`;
    const button = document.createElement('DIV');
    button.classList.add('bt-wishlist-remove-button', 'hidden');
    button.setAttribute('data-product-handle', prdHandle);
    button.innerHTML = html;
    return button;
  }

  renderWishlistPage = async () => {
    const container = document.querySelector(this.selectors.container);
    const skeleton = document.querySelectorAll(this.selectors.skeleton);
    if (container) {
      let noItemAvailable = true;
      if (this.products.length) {
        const promises = this.products.map(async (hdl) => {
          const url = formatUrl('products', hdl, 'view=wishlist-item');
          const prodHTML = await fetchCache(url);
          const item = document.createElement('li');
          item.classList.add('hidden', 'bt-wishlist-card', 'grid__item');
          item.innerHTML = prodHTML;
          if (item.querySelector(this.selectors.productCard)) {
            noItemAvailable = false;
            //item.appendChild(this.wishlistRemoveButton(hdl));
            this.productNodes[hdl] = item;
          }
        });

        await Promise.all(promises);

        // Render in order
        skeleton.forEach((item) => {
          item.remove();
        });
        this.products.forEach((hdl) => {
          const prod = this.productNodes[hdl];
          if (prod) {
            container.appendChild(prod);

            if (UtenzoTheme.CompareProduct) {
              UtenzoTheme.CompareProduct.setCompareButtonsState();
            }

            prod.classList.remove('hidden');
          }
        });
      }

      if (noItemAvailable) {
        this.showNoProductsMessage();
      } else {
        this.setWishlistButtonsState();
      }

      container.classList.add('is-visible');
    }
  };

  showNoProductsMessage = () => {
    const container = document.querySelector(this.selectors.container);
    const noProducts = document.querySelector(this.selectors.noProducts);

    container.classList.add('hidden');
    noProducts.classList.remove('hidden');
  };
}

UtenzoTheme.Wishlist = new Wishlist();